import { render, staticRenderFns } from "./showPaper.vue?vue&type=template&id=471f3e55&scoped=true"
import script from "./showPaper.vue?vue&type=script&lang=js"
export * from "./showPaper.vue?vue&type=script&lang=js"
import style0 from "./showPaper.vue?vue&type=style&index=0&id=471f3e55&prod&lang=scss"
import style1 from "./showPaper.vue?vue&type=style&index=1&id=471f3e55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f3e55",
  null
  
)

export default component.exports